
import UserContext from "context/UserContext";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router";
import ApiService from "../../infrastructure/Services/ApiService";
import StorageService from '../../infrastructure/StorageService';
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    NavItem,
    Input,
    Nav,
    Container,
    Row,
    Col,
    Table
} from "reactstrap";
import { toast } from 'react-toastify';

export default (() => {
    const [data, setData] = useState(null);
    const [sort, setSort] = useState({ field: 'yearLevel', direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [filterYearLevel, setFilterYearLevel] = useState('');
    const [filterYear, setFilterYear] = useState('');
    const [filterUserName, setFilterUserName] = useState('');
    const user = useContext(UserContext);
    const history = useHistory();
    // Helper to sort items consistently (handles yearLevel numeric and year numeric)
    const sortItems = (items, fieldParam, directionParam) => {
        if (!items) return [];
        const field = fieldParam || sort.field;
        const direction = directionParam || sort.direction;
        const sorted = [...items].sort((a, b) => {
            const aRaw = a[field];
            const bRaw = b[field];

            // yearLevel contains non-digit prefixes like 'Y10' or 'Year 10' - extract numeric
            if (field === 'yearLevel') {
                const aStr = (aRaw || '').toString();
                const bStr = (bRaw || '').toString();
                const aNumMatch = aStr.match(/\d+/);
                const bNumMatch = bStr.match(/\d+/);
                const aHasNum = !!aNumMatch;
                const bHasNum = !!bNumMatch;

                // If both have numbers, compare numerically (preserve existing behaviour)
                if (aHasNum && bHasNum) {
                    const an = parseInt(aNumMatch[0], 10) || 0;
                    const bn = parseInt(bNumMatch[0], 10) || 0;
                    return direction === 'asc' ? an - bn : bn - an;
                }

                // If one has a number and the other doesn't, place numeric ones first
                if (aHasNum && !bHasNum) return direction === 'asc' ? -1 : 1;
                if (!aHasNum && bHasNum) return direction === 'asc' ? 1 : -1;

                // Neither has numbers: fallback to case-insensitive string compare
                const as = aStr.toLowerCase();
                const bs = bStr.toLowerCase();
                if (as < bs) return direction === 'asc' ? -1 : 1;
                if (as > bs) return direction === 'asc' ? 1 : -1;
                return 0;
            }

            // year is numeric
            if (field === 'year') {
                const an = parseInt(aRaw) || 0;
                const bn = parseInt(bRaw) || 0;
                return direction === 'asc' ? an - bn : bn - an;
            }

            // default string compare (case-insensitive)
            const as = (aRaw || '').toString().toLowerCase();
            const bs = (bRaw || '').toString().toLowerCase();
            if (as < bs) return direction === 'asc' ? -1 : 1;
            if (as > bs) return direction === 'asc' ? 1 : -1;
            return 0;
        });
        return sorted;
    };
    const getData = async () => {
        ApiService.get(`savedbookings/lab/`)
            .then(resp => {
                const items = resp && resp.items ? resp.items : [];
                const sorted = sortItems(items, sort.field, sort.direction);
                setData(sorted);
            })
    }


    const sortData = (field) => {
        const direction = sort.field === field && sort.direction === 'asc' ? 'desc' : 'asc';
        setSort({ field, direction });
        if (!data) return;
        const sortedData = sortItems(data, field, direction);
        setData(sortedData);
    };

    useEffect(() => {

        getData();
    }, []);

    const deleteLesson = (id) => {
        const confirmDelete = window.confirm("Are you sure you would like to delete this booking?");
        if (!confirmDelete) return;


        ApiService.delete(`savedbooking/lab/${id}`).then(resp => {
            toast.success("Saved Booking Deleted");
            if (resp && resp.items) {

                const sorted = sortItems(resp.items);
                setData(sorted);
            }
        })
    }

    const renameLesson = (id, currentName) => {
        const newName = window.prompt("Enter a new name for this saved booking:", currentName);
        if (!newName || newName.length === 0) return;

        ApiService.put(`savedbooking/lab/${id}`, { practicalName: newName }).then(resp => {
            toast.success("Saved Booking Renamed");
            if (resp && resp.items) {
                const sorted = sortItems(resp.items);
                setData(sorted);
            }
        })
    }

    return <>
        <Container className="mt--7" fluid>
            <Row>
                <Col className="mb-5 mb-xl-0" xl="12">
                    <Card className="shadow">
                        <CardHeader className="bg-transparent">
                            <Row className="align-items-center">
                                <Col className=" d-flex align-items-center justify-content-between">
                                    <h3>Administration &gt; Saved Bookings</h3>

                                </Col>

                            </Row>
                            <Row className="align-items-center mt-3">
                                <Col md="3">
                                    <Input
                                        type="select"
                                        value={filterYearLevel}
                                        onChange={(e) => setFilterYearLevel(e.target.value)}
                                    >
                                        <option value="">All Year Levels</option>
                                        {data && [...new Set(data.map(item => item.yearLevel))].filter(Boolean).sort((a, b) => {
                                            const aNum = parseInt((a || '').toString().match(/\d+/)?.[0]) || 0;
                                            const bNum = parseInt((b || '').toString().match(/\d+/)?.[0]) || 0;
                                            return aNum - bNum;
                                        }).map(yl => <option key={yl} value={yl}>{yl}</option>)}
                                    </Input>
                                </Col>
                                <Col md="3">
                                    <Input
                                        type="select"
                                        value={filterYear}
                                        onChange={(e) => setFilterYear(e.target.value)}
                                    >
                                        <option value="">All Years</option>
                                        {data && [...new Set(data.map(item => item.year))].filter(Boolean).sort((a, b) => b - a).map(yr => <option key={yr} value={yr}>{yr}</option>)}
                                    </Input>
                                </Col>
                                <Col md="3">
                                    <Input
                                        type="select"
                                        value={filterUserName}
                                        onChange={(e) => setFilterUserName(e.target.value)}
                                    >
                                        <option value="">All Users</option>
                                        {data && [...new Set(data.map(item => item.userName))].filter(Boolean).sort().map(un => <option key={un} value={un}>{un}</option>)}
                                    </Input>
                                </Col>
                                <Col md="3">
                                    <Input
                                        type="text"
                                        placeholder="Type to filter/search..."
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </CardHeader><CardBody>


                            <Table className="align-items-center table-flush" responsive>
                                <thead className="thead-light">
                                    <tr>
                                        <th scope="col"><a className="cursor-pointer" onClick={() => sortData('yearLevel')}>Year Level <i className={`fa ${sort.field === 'yearLevel' ? (sort.direction === 'asc' ? 'fa-chevron-up' : 'fa-chevron-down') : ''}`} /></a></th>
                                        <th scope="col"><a className="cursor-pointer" onClick={() => sortData('name')}>Practical Name <i className={`fa ${sort.field === 'name' ? (sort.direction === 'asc' ? 'fa-chevron-up' : 'fa-chevron-down') : ''}`} /></a></th>
                                        <th scope="col"><a className="cursor-pointer" onClick={() => sortData('userName')}>User <i className={`fa ${sort.field === 'userName' ? (sort.direction === 'asc' ? 'fa-chevron-up' : 'fa-chevron-down') : ''}`} /></a></th>
                                        <th scope="col"><a className="cursor-pointer" onClick={() => sortData('year')}>Year <i className={`fa ${sort.field === 'year' ? (sort.direction === 'asc' ? 'fa-chevron-up' : 'fa-chevron-down') : ''}`} /></a></th>
                                        <th scope="col" />
                                    </tr>
                                </thead>
                                <tbody>
                                    {data && data.filter(savedBooking => {
                                        const matchesSearch = savedBooking.name.toLowerCase().includes(searchTerm.toLowerCase());
                                        const matchesYearLevel = !filterYearLevel || savedBooking.yearLevel === filterYearLevel;
                                        const matchesYear = !filterYear || savedBooking.year?.toString() === filterYear;
                                        const matchesUserName = !filterUserName || savedBooking.userName === filterUserName;
                                        return matchesSearch && matchesYearLevel && matchesYear && matchesUserName;
                                    }).map(savedBooking =>
                                        <tr key={savedBooking.id}>
                                            <td>{savedBooking.yearLevel}</td>
                                            <td><a href={`#`} onClick={(e) => { e.preventDefault(); history.push(`/lab/saved-booking/${savedBooking.id}`); }}>{savedBooking.name}</a></td>
                                            <td>{savedBooking.userName}</td>
                                            <td>{savedBooking.year}</td>
                                            <td>
                                                {user.isAdmin && <>
                                                    <i
                                                        className={`fa fa-times cursor-pointer float-right`}
                                                        onClick={() => deleteLesson(savedBooking.id)}
                                                    ></i>


                                                    <i
                                                        className={`fa fa-edit cursor-pointer float-right mr-3`}
                                                        onClick={() => renameLesson(savedBooking.id, savedBooking.name)}
                                                    ></i>
                                                </>}
                                            </td>
                                        </tr>
                                    )}


                                </tbody>
                            </Table>

                            {/* {data && <>
                                {data.map((campus, ci) => <><Row>{
                                    <Col>
                                        <h4>{campus.name}</h4>
                                    </Col>

                                }</Row>

                                    <Row>
                                        <Col>
                                            <h5>Year Levels</h5>
                                            {campus.yearLevels.map((year, i) =>
                                                <div key={`y_${i}`} className="rounded d-flex align-items-center justify-content-between p-3 bg-light w-100 mb-3 float-left">
                                                    <span className="float-left">{year}</span>
                                                    <i
                                                        className={`fa fa-times cursor-pointer`}
                                                        onClick={(e) => {
                                                            setData((prevState) => {
                                                                const newState = [...prevState];
                                                                newState[ci].yearLevels.splice(i, 1);
                                                                return newState;

                                                            })
                                                        }}
                                                    ></i>
                                                </div>
                                            )}


                                            <div className="rounded py-3 w-100 mb-3">

                                                <Input type="text" value={newYear} className="form-control w-100 mb-1" onChange={e => {
                                                    const v = e.target.value;
                                                    setNewYear(v)
                                                }} />

                                                <button className="btn btn-primary w-100" disabled={!(newYear && newYear.length > 0)} onClick={() => {
                                                    setData((prevState) => {
                                                        const newState = [...prevState];
                                                        newState[ci].yearLevels.push(newYear);
                                                        return newState;
                                                    });
                                                    setNewYear('');
                                                }}>Add Year Level</button>
                                            </div>
                                        </Col>


                                        <Col>
                                            <h5>Classes</h5>
                                            {campus.classes.map((cls, i) =>
                                                <div key={`c_${i}`} className="rounded d-flex align-items-center justify-content-between p-3 bg-light w-100 mb-3 float-left">
                                                    <span className="float-left">{cls.name} - {cls.yearLevel}</span>
                                                    <i
                                                        className={`fa fa-times cursor-pointer`}
                                                        onClick={(e) => {
                                                            setData((prevState) => {
                                                                const newState = [...prevState];
                                                                newState[ci].classes.splice(i, 1);
                                                                return newState;

                                                            })
                                                        }}
                                                    ></i>
                                                </div>
                                            )}


                                            <div className="rounded py-3 w-100 mb-3">

                                                <Input type="text" value={newClass.name} className="form-control w-100 mb-1" onChange={e => {
                                                    const v = e.target.value;
                                                    setNewClass(prevState => {
                                                        const newState = { ...prevState };
                                                        newState.name = v
                                                        return newState;
                                                    })
                                                }} />
                                                <select className="form-control w-100 mb-1" onChange={e => {
                                                    const v = e.target.value;
                                                    setNewClass(prevState => {
                                                        const newState = { ...prevState };
                                                        newState.yearLevel = v
                                                        return newState;
                                                    })
                                                }}>
                                                    <option>Select...</option>
                                                    {campus.yearLevels.map((yl) => <option>{yl}</option>)}
                                                </select>
                                                <button className="btn btn-primary w-100" disabled={!(newClass.name && newClass.name.length > 0 && newClass.yearLevel && newClass.yearLevel.length > 0)} onClick={() => {
                                                    setData((prevState) => {
                                                        const newState = [...prevState];
                                                        newState[ci].classes.push(newClass);
                                                        return newState;
                                                    });
                                                    setNewClass({ name: '', yearLevel: '' });
                                                }}>Add Class</button>
                                            </div>

                                        </Col>
                                        <Col>
                                            <h5>Rooms</h5>
                                            {campus.rooms.map((room, i) =>
                                                <div key={`r_${i}`} className="rounded d-flex align-items-center justify-content-between p-3 bg-light w-100 mb-3 float-left">
                                                    <span className="float-left">{room}</span>
                                                    <i
                                                        className={`fa fa-times cursor-pointer`}
                                                        onClick={(e) => {
                                                            setData((prevState) => {
                                                                const newState = [...prevState];
                                                                newState[ci].rooms.splice(i, 1);
                                                                return newState;
                                                            })
                                                        }}
                                                    ></i>
                                                </div>
                                            )}


                                            <div className="rounded py-3 w-100 mb-3">

                                                <Input type="text" value={newRoom} className="form-control w-100 mb-1" onChange={e => {
                                                    const v = e.target.value;
                                                    setNewRoom(v)
                                                }} />

                                                <button className="btn btn-primary w-100" disabled={!(newRoom && newRoom.length > 0)} onClick={() => {
                                                    setData((prevState) => {
                                                        const newState = [...prevState];
                                                        newState[ci].rooms.push(newRoom);
                                                        return newState;
                                                    });
                                                    setNewRoom('');
                                                }}>Add Room</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </>
                                )}
                            </>} */}

                        </CardBody>

                    </Card></Col></Row ></Container >

    </>;
})